
















































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import Manual from '@/views/AiiTasks/manual.vue'
import TaskApi from '@/api/task.ts'
import { TOKEN } from '@/store/mutation-types'

let body = document.body || document.documentElement
const initContent = {
	title: '',
	itemList: [
		{
			title: '',
			content: '',
		},
	],
}

@Component({
	name: 'manualPreview',
	components: {
		Manual,
	},
})
export default class ModifyManual extends Vue {
	private visibleTips: boolean = false
	// 当前修改的板块id
	private modifyingSec: number = -1
	// 当前修改的版块列表id
	private modifyingItem: number = -1
	// 当前需要编辑的类型
	private modifyingType: string = ''
	// 右侧编辑form
	private manualForm: any = {}
	private manual: any = {}
	private contactInfo: any = {}
	private desc: any = {}
	private contentList: any = {}
	private image: any = {}
	private manualCopy: any = {}
	private visiblePreview: boolean = false

	@Prop()
	private qrUploaded!: string

	@Prop()
	private previewing!: boolean

	@Prop()
	private qrCodeSrc!: string

	@Watch('qrCodeSrc')
	private onQrCodeLoad() {
		Object.assign(this.image, {
			id: '',
			url: this.qrCodeSrc,
			desc: '',
		})
		this.manual.imageList[0] = this.image
		this.manual = { ...this.manual }
		this.$nextTick(() => {
			let qrCodeWrap = document.querySelector('.qr-wrap')
			this.scrollToEl(qrCodeWrap)
		})
	}

	@Watch('previewing')
	private showPreview() {
		if (this.previewing) {
			this.manualCopy = cloneDeep(this.manual)
			this.visiblePreview = true
		}
	}

	@Watch('visiblePreview')
	private hiddenPreview() {
		if (!this.visiblePreview) {
			this.$emit('changePreview', false)
		}
	}

	private get notPreview(): boolean {
		return !(
			this.$route.query.isPreview ||
			(this.$route.params.orderId && this.$route.params.token)
		)
	}

	private get isH5(): boolean {
		return !!(this.$route.params.orderId && this.$route.params.token)
	}
	// 不带pageLayout预览
	private get manualOnly(): boolean {
		return !!(
			this.$route.query.isPreview ||
			(this.$route.params.orderId && this.$route.params.token)
		)
	}

	private disableToggle(type: string) {
		if (type === 'contactInfo') {
			this.contactInfo.disable = !this.contactInfo.disable
		} else {
			this.desc.disable = !this.desc.disable
			if (this.desc.disable) {
				this.resetManualForm()
			}
		}
	}

	private modifyStuff(payload: any) {
		this.modify(payload)
	}

	private modify(payload: any) {
		const { type, contentIndex, itemIndex } = payload
		if (this.modifyingType.length > 0) {
			this.resetManualForm()
		}
		this.modifyingType = type
		this.modifyingSec = contentIndex
		this.modifyingItem = itemIndex
		if (type === 'item') {
			this.manualForm.setFieldsValue({
				contentName: this.contentList[contentIndex].title,
			})
		}
	}

	private addStuff(payload: any) {
		const { type, contentIndex, itemIndex } = payload
		if (type === 'content') {
			this.contentList.splice(contentIndex + 1, 0, cloneDeep(initContent))
			this.scrollToSec(contentIndex)
			this.modify(
				Object.assign(payload, {
					contentIndex: contentIndex + 1,
				})
			)
		} else if (type === 'item') {
			const {
				itemList: [initItem],
			} = cloneDeep(initContent)
			this.contentList[contentIndex].itemList.splice(itemIndex + 1, 0, initItem)
			this.modify(
				Object.assign(payload, {
					itemIndex: itemIndex + 1,
				})
			)
		}
	}

	private removeStuff(payload: any) {
		const { type, contentIndex, itemIndex } = payload
		if (type === 'qrCode') {
			Object.assign(this.image, {
				id: '',
				url: '',
				desc: '',
			})
			this.manual = { ...this.manual }
			this.$emit('gotQrCode', false)
		} else if (type === 'content') {
			this.contentList.splice(contentIndex, 1)
		} else {
			if (type === 'desc') {
				this.contentList[contentIndex].desc = ''
			} else if (type === 'comment') {
				this.contentList[contentIndex].comment = ''
			} else if (type === 'item') {
				this.contentList[contentIndex].itemList.splice(itemIndex, 1)
			}
			let currentContent = this.contentList[contentIndex]
			// 板块中已不存在内容则去除板块
			if (
				currentContent.itemList.length === 0 &&
				!currentContent.desc &&
				!currentContent.comment
			) {
				this.removeStuff({
					type: 'content',
					contentIndex: contentIndex,
				})
				this.resetManualForm()
			}
		}
	}

	private scrollToEl(el: any) {
		if ('scrollBehavior' in el.style) {
			el.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
				inline: 'nearest',
			})
		} else {
			el.scrollIntoView(true)
		}
	}

	private scrollToSec(index: number) {
		let contentEls: any = document.querySelectorAll('.manual-sec')
		this.scrollToEl(contentEls[index])
	}

	private modifyConfirmed() {
		this.manualForm.validateFields((err: any, values: any) => {
			if (!err) {
				if (this.modifyingType === 'coverDesc') {
					this.desc.content = values.content
				} else if (this.modifyingType === 'title') {
					this.contentList[this.modifyingSec].title = values.contentName
				} else if (this.modifyingType === 'comment') {
					this.contentList[this.modifyingSec].comment = values.content
				} else if (this.modifyingType === 'desc') {
					this.contentList[this.modifyingSec].desc = values.content
				} else if (this.modifyingType === 'item') {
					if (this.modifyingSec >= 0 && this.modifyingItem >= 0) {
						Object.assign(
							this.contentList[this.modifyingSec].itemList[this.modifyingItem],
							{
								title: values.itemName,
								content: values.content,
							}
						)
					}
				} else if (this.modifyingType === 'content') {
					Object.assign(this.contentList[this.modifyingSec], {
						title: values.contentName,
						itemList: [
							{
								title: values.itemName,
								content: values.content,
							},
						],
					})
				}
				this.resetManualForm()
			}
		})
	}

	private isEmptyStuff(payload: any) {
		const { type, contentIndex, itemIndex } = payload
		let currentContent = this.manual.contentList[contentIndex]
		if (type === 'content') {
			return !currentContent.title
		} else if (type === 'item') {
			let currentItem = currentContent.itemList[itemIndex]
			return !currentItem.title && !currentItem.content
		}
	}

	private modifyCancel() {
		if (this.modifyingType.length > 0) {
			if (this.modifyingType === 'content' || this.modifyingType === 'item') {
				let payload = {
					type: this.modifyingType,
					contentIndex: this.modifyingSec,
					itemIndex: this.modifyingItem,
				}
				if (this.isEmptyStuff(payload)) {
					this.removeStuff(payload)
				}
			}
		}
		this.resetManualForm()
	}

	private resetManualForm() {
		this.manualForm.setFieldsValue({
			contentName: '',
			itemName: '',
			content: '',
		})
		this.modifyingType = ''
		this.modifyingSec = -1
		this.modifyingItem = -1
	}

	private modifyImageDesc(desc: string) {
		this.image.desc = desc
	}

	private tipsConfirm() {
		this.$ls.set('checkManualTip', true)
		body.style.overflow = 'auto'
		this.visibleTips = false
	}

	private async created() {
		// 是否展示引导modal
		if (this.notPreview && !this.$ls.get('checkManualTip')) {
			this.visibleTips = true
			body.style.overflow = 'hidden'
		}

		this.manualForm = this.$form.createForm(this)
		let res: any = {}
		if (this.isH5) {
			const orderId = this.$route.params.orderId
			const token = this.$route.params.token
			body.style.width = '375px'
			body.style.minWidth = 'auto'
			this.$ss.set(TOKEN, token)
			res = await TaskApi.getH5TaskManual({
				orderId: orderId,
				token: token,
			})
		} else {
			res = await TaskApi.getTaskManual()
		}
		this.manual = res.data
		this.contactInfo = res.data.cover.contactInfo
		this.desc = res.data.cover.desc
		this.contentList = res.data.contentList
		this.image = res.data.imageList[0] || {}
		if (this.notPreview) {
			this.$emit(
				'gotQrCode',
				!!(this.image && (this.image.url || this.image.desc))
			)
		}
	}
}
